export const navigateTo = (path) => window.location.assign(path)
